<template>
  <div
    :class="[
      'tw-flex tw-items-center tw-justify-between tw-gap-10',
      'tw-p-5',
      'tw-rounded-lg tw-shadow-md',
      'tw-bg-gray-100',
      'tw-border tw-border-slate-200',
    ]"
  >
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-1">
      <p class="tw-text-base tw-font-bold">
        {{ platform.name.internal }}
      </p>
    </div>

    <div>
      <div
        v-if="isActive"
        class="tw-flex tw-gap-2"
      >
        <div
          class="button-base tw-bg-emerald-300 tw-text-gray-600"
        >
          <i class="fa fa-check" />
          Active
        </div>

        <button
          class="button-base tw-bg-rose-700 tw-text-white tw-opacity-50 hover:tw-opacity-100 tw-cursor-pointer"
          @click="deleteCalendar"
        >
          <i :class="['fa', deletePending ? 'fa-spinner fa-spin' : 'fa-times-circle']" />
          Disable
        </button>
      </div>

      <div
        v-else-if="isActive === undefined"
        class="button-base tw-bg-gray-300 tw-text-gray-500"
        @click="createCalendar"
      >
        <i class="fa fa-spinner fa-spin" />
        Checking
      </div>

      <button
        v-else
        class="button-base tw-bg-sky-600 hover:tw-bg-sky-700 tw-text-gray-200 hover:tw-text-white tw-cursor-pointer"
        @click="createCalendar"
      >
        <i :class="['fa', pending ? 'fa-spinner fa-spin' : 'fa-plug']" />
        Enable
      </button>
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
import { mapStores } from 'pinia';

export default {
  name: 'MeetingBotCalendarToggle',
  components: { /* Subcomponents */ },
  props: {
    platform: {
      type: Object,
      required: true,
    },
    activeCalendars: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      pending: null,
      deletePending: null,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    ...mapStores(useAdvisorStore),
    isActive() {
      if (!this.activeCalendars) return undefined;
      return this.activeCalendars[this.platform.name.external] ? true : false;
    },
    headers() {
      return {
        'X-CSRFToken': this.$root.$data.csrfToken,
        'Content-Type': 'application/json',
      };
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    async createCalendar() {
      this.pending = true;
      const res = await fetch('/api/v1/recall/calendars/', {
        method: 'POST',
        headers: this.headers,
        body: JSON.stringify({ platform: this.platform }),
      });
      const calendar = await res.json();

      this.$emit('created', calendar);
      this.pending = false;
    },
    async deleteCalendar() {
      this.deletePending = true;
      const res = await fetch('/api/v1/recall/calendars/', {
        method: 'DELETE',
        headers: this.headers,
        body: JSON.stringify({ platform: this.platform }),
      });

      if (res.status === 204) {
        this.deletePending = false;
        this.$emit('deleted', this.platform);
        //
      } else {
        // If we are here then something went wrong
        const data = await res.json();
        console.log(data);
      }
    },
  },
};
</script>


<style scoped>
  .button-base {
    @apply tw-text-base;
    @apply tw-px-4 tw-py-2 tw-rounded-md tw-border-none;
    @apply tw-flex tw-gap-2 tw-items-center tw-justify-center;
  }
</style>
